import * as React from "react";
import asoleacion from "../../../UI/general/asoleacion.svg";
import Stack from "@mui/material/Stack";
import Slider from "@mui/material/Slider";
import { styled, useTheme } from "@mui/material/styles";
import amanecerIcon from "../../../UI/asoleacion/amanecer.svg";
import mediodiaIcon from "../../../UI/asoleacion/mediodia.svg";
import atardecerIcon from "../../../UI/asoleacion/atardecer.svg";
import nocheIcon from "../../../UI/asoleacion/noche.svg";

declare const window: any;

export default function AsoleacionContainer({
  vistas,
  theme,
  colors,
  setIsMomentDay,
  isMomentDay,
  setIsVew,
  isView,
  setSelectedTime,
  selectedTime,
  setIsSideBar,
  isSideBar,
  setIShowAsoleacion,
  setFrame,
  keyTime,
  isPortrait,
}) {
  const themee = useTheme();
  const duration = 100; // seconds
  const [position, setPosition] = React.useState(32);
  const [dragging, setDragging] = React.useState(false);
  const [alt, setAlt] = React.useState(false);
  const [startX, setStartX] = React.useState(0);
  const [startY, setStartY] = React.useState(0);
  const [angle, setAngle] = React.useState(0);

  const sliderRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    setAlt(true);
  }, []);

  React.useEffect(() => {
    const content_asoleacion: any = document.querySelector(
      ".asoleacion-sidebar-mobile"
    );
    if (!isSideBar) {
      setTimeout(() => {
        if (content_asoleacion) {
          content_asoleacion.style.display = "none";
        }
      }, 1000);
    } else {
      if (content_asoleacion) {
        content_asoleacion.style.display = "block";
      }
    }
  }, [isSideBar]);

  React.useEffect(() => {
    setAlt(false);
  }, []);

  React.useEffect(() => {
    let ball: any = document.querySelector(".asoleacion-sidebar-slider-ball");
    if (ball) {
      ball.style.transition = "transform 3s ease-in-out";
      setTimeout(() => {
        ball.style.transition = "none";
      }, 3001);
    }
  }, [isMomentDay]);

  React.useEffect(() => {
    let ball: any = document.querySelector(".asoleacion-sidebar-slider-ball");
    if (ball) {
      ball.style.transition = "transform 3s ease-in-out";
      setTimeout(() => {
        ball.style.transition = "none";
      }, 3001);
    }
  }, [isView]);

  const animacionAUT = () => {
    let btnAut: any = document.querySelector(
      ".asoleacion-sidebar-vistas-buttons-auto"
    );
    let btnMomentAmanecer: any = document.querySelector(".v-Amanecer");
    let btnMomentMedioDia: any = document.querySelector(".v-MedioDia");
    let btnMomentAtardecer: any = document.querySelector(".v-Atardecer");
    let btnMomentNoche: any = document.querySelector(".v-Noche");
    let vista1: any = document.querySelector(".vista-0");
    let vista2: any = document.querySelector(".vista-1");
    let vista3: any = document.querySelector(".vista-2");
    btnAut.style.backgroundColor = colors?.main_buttons;
    btnAut.style.color = "#fff";
    btnAut.style.pointerEvents = "none";
    btnAut.style.cursor = "none";
    btnMomentAmanecer.style.pointerEvents = "none";
    btnMomentAmanecer.style.cursor = "none";
    btnMomentMedioDia.style.pointerEvents = "none";
    btnMomentMedioDia.style.cursor = "none";
    btnMomentAtardecer.style.pointerEvents = "none";
    btnMomentAtardecer.style.cursor = "none";
    btnMomentNoche.style.pointerEvents = "none";
    btnMomentNoche.style.cursor = "none";
    vista1.style.pointerEvents = "none";
    vista1.style.cursor = "none";
    vista2.style.pointerEvents = "none";
    vista2.style.cursor = "none";
    vista3.style.pointerEvents = "none";
    vista3.style.cursor = "none";
    let FinaliTime = 0;

    //setIsMomentDay("")

    let intervalAUT = setInterval(() => {
      FinaliTime++;
      setSelectedTime((prevSelectedTime) => {
        let newSelectedTime =
          prevSelectedTime + 1 <= 100 ? prevSelectedTime + 1 : 1;
        const grados = (newSelectedTime / 100) * 360;
        setAngle(grados);
        return newSelectedTime;
      });

      if (FinaliTime === 100) {
        clearInterval(intervalAUT);
        btnAut.style.backgroundColor = "rgba(0, 0, 0, 0.4)";
        btnAut.style.color = "#fff";
        btnAut.style.pointerEvents = "auto";
        btnAut.style.cursor = "pointer";
        btnMomentAmanecer.style.pointerEvents = "auto";
        btnMomentAmanecer.style.cursor = "pointer";
        btnMomentMedioDia.style.pointerEvents = "auto";
        btnMomentMedioDia.style.cursor = "pointer";
        btnMomentAtardecer.style.pointerEvents = "auto";
        btnMomentAtardecer.style.cursor = "pointer";
        btnMomentNoche.style.pointerEvents = "auto";
        btnMomentNoche.style.cursor = "pointer";
        vista1.style.pointerEvents = "auto";
        vista1.style.cursor = "pointer";
        vista2.style.pointerEvents = "auto";
        vista2.style.cursor = "pointer";
        vista3.style.pointerEvents = "auto";
        vista3.style.cursor = "pointer";
      }
    }, 68.5);
  };

  const animationDay = () => {};

  const goToFrame = (targetFrame: number) => {
    const totalFrames = 100;
    const targetAngle = (targetFrame / totalFrames) * 360;

    let diff = targetAngle - angle;

    // Normalizar la diferencia al rango -180 a 180
    if (diff > 180) diff -= 360;
    if (diff < -180) diff += 360;

    const newAngle = angle + diff;

    setSelectedTime(targetFrame);
    setAngle(newAngle);
  };

  const goToFrameClockwise = (targetFrame: number) => {
    const totalFrames = 100;
    let targetAngle = (targetFrame / totalFrames) * 360;

    let currentAngle = angle % 360; // normalizar el ángulo actual entre 0-360

    // Asegurar que siempre gire hacia adelante
    if (targetAngle <= currentAngle) {
      targetAngle += 360;
    }

    // Acumular el giro (mantener continuidad)
    const newAngle = Math.floor(angle / 360) * 360 + targetAngle;
    setSelectedTime(targetFrame);
    setAngle(newAngle);
  };

  const marks = [
    {
      value: 1,
      label: (
        <div
          className="asoleacion-sidebar-slider-button v-Amanecer col col-6"
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = darkenColor(
              colors?.main_buttons,
              0
            );
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor = "";
          }}
          onClick={() => {
            setIsMomentDay("Amanecer"), goToFrameClockwise(1);
            /* setSelectedTime(1),
              setAngle((1 / 100) * 360); */
          }}
        >
          <img
            src={amanecerIcon}
            alt="Amanecer"
            className="slider-icon"
            style={
              isMomentDay === "Amanecer"
                ? { filter: "invert(1) brightness(100%)" }
                : {}
            }
          />{" "}
          <div>Amanecer</div>
        </div>
      ),
    },
    {
      value: 100,
      label: (
        <div
          className="asoleacion-sidebar-slider-button  v-MedioDia col col-6"
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = darkenColor(
              colors?.main_buttons,
              0
            );
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor = "";
          }}
          onClick={() => {
            setIsMomentDay("MedioDia"), goToFrameClockwise(24);
            /* setSelectedTime(24),
              setAngle((24 / 100) * 360); */
          }}
        >
          <img
            src={mediodiaIcon}
            alt="Medio día"
            className="slider-icon"
            style={
              isMomentDay === "MedioDia"
                ? { filter: "invert(1) brightness(100%)" }
                : {}
            }
          />{" "}
          <div>Medio día</div>
        </div>
      ),
    },
    {
      value: 50,
      label: (
        <div
          className="asoleacion-sidebar-slider-button v-Atardecer col col-6"
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = darkenColor(
              colors?.main_buttons,
              0
            );
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor = "";
          }}
          onClick={() => {
            setIsMomentDay("Atardecer"), goToFrameClockwise(48);
            /* setSelectedTime(48),
              setAngle((48 / 100) * 360); */
          }}
        >
          <img
            src={atardecerIcon}
            alt="Atardecer"
            className="slider-icon"
            style={
              isMomentDay === "Atardecer"
                ? { filter: "invert(1) brightness(100%)" }
                : {}
            }
          />{" "}
          <div>Atardecer</div>
        </div>
      ),
    },
    {
      value: 1,
      label: (
        <div
          className="asoleacion-sidebar-slider-button v-Noche col col-6"
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = darkenColor(
              colors?.main_buttons,
              0
            );
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor = "";
          }}
          onClick={() => {
            setIsMomentDay("Noche"), goToFrameClockwise(72);
            /* setSelectedTime(72),
              setAngle((72 / 100) * 360); */
          }}
        >
          <img
            src={nocheIcon}
            alt="Noche"
            className="slider-icon"
            style={
              isMomentDay === "Noche"
                ? { filter: "invert(1) brightness(100%)" }
                : {}
            }
          />{" "}
          <div>Noche</div>
        </div>
      ),
    },
  ];

  const marks_movil = [
    {
      value: 1,
      label: (
        <div
          className="asoleacion-sidebar-slider-button"
          style={
            isMomentDay === "Amanecer"
              ? { backgroundColor: colors?.main_buttons, color: "#fff" }
              : {}
          }
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = darkenColor(
              colors?.main_buttons,
              0
            );
          }}
          onMouseOut={(e) => {
            isMomentDay !== "Amanecer"
              ? (e.currentTarget.style.backgroundColor = "")
              : null;
          }}
          onClick={() => {
            setIsMomentDay("Amanecer"),
              setSelectedTime(1),
              setAngle((1 / 100) * 360);
          }}
        >
          <img
            src={amanecerIcon}
            alt="Amanecer"
            className="slider-icon"
            style={
              isMomentDay === "Amanecer"
                ? { filter: "invert(1) brightness(100%)" }
                : {}
            }
          />{" "}
        </div>
      ),
    },
    {
      value: 24,
      label: (
        <div
          className="asoleacion-sidebar-slider-button"
          style={
            isMomentDay === "MedioDia"
              ? { backgroundColor: colors?.main_buttons, color: "#fff" }
              : {}
          }
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = darkenColor(
              colors?.main_buttons,
              0
            );
          }}
          onMouseOut={(e) => {
            isMomentDay !== "MedioDia"
              ? (e.currentTarget.style.backgroundColor = "")
              : null;
          }}
          onClick={() => {
            setIsMomentDay("MedioDia"),
              setSelectedTime(24),
              setAngle((24 / 100) * 360);
          }}
        >
          <img
            src={mediodiaIcon}
            alt="Medio día"
            className="slider-icon"
            style={
              isMomentDay === "MedioDia"
                ? { filter: "invert(1) brightness(100%)" }
                : {}
            }
          />{" "}
        </div>
      ),
    },
    {
      value: 48,
      label: (
        <div
          className="asoleacion-sidebar-slider-button"
          style={
            isMomentDay === "Atardecer"
              ? { backgroundColor: colors?.main_buttons, color: "#fff" }
              : {}
          }
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = darkenColor(
              colors?.main_buttons,
              0
            );
          }}
          onMouseOut={(e) => {
            isMomentDay !== "Atardecer"
              ? (e.currentTarget.style.backgroundColor = "")
              : null;
          }}
          onClick={() => {
            setIsMomentDay("Atardecer"),
              setSelectedTime(48),
              setAngle((48 / 100) * 360);
          }}
        >
          <img
            src={atardecerIcon}
            alt="Atardecer"
            className="slider-icon"
            style={
              isMomentDay === "Atardecer"
                ? { filter: "invert(1) brightness(100%)" }
                : {}
            }
          />{" "}
        </div>
      ),
    },
    {
      value: 72,
      label: (
        <div
          className="asoleacion-sidebar-slider-button"
          style={
            isMomentDay === "Noche"
              ? { backgroundColor: colors?.main_buttons, color: "#fff" }
              : {}
          }
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = darkenColor(
              colors?.main_buttons,
              0
            );
          }}
          onMouseOut={(e) => {
            isMomentDay !== "Noche"
              ? (e.currentTarget.style.backgroundColor = "")
              : null;
          }}
          onClick={() => {
            setIsMomentDay("Noche"),
              setSelectedTime(72),
              setAngle((72 / 100) * 360);
          }}
        >
          <img
            src={nocheIcon}
            alt="Noche"
            className="slider-icon"
            style={
              isMomentDay === "Noche"
                ? { filter: "invert(1) brightness(100%)" }
                : {}
            }
          />{" "}
        </div>
      ),
    },
  ];

  const CustomSlider = styled(Slider)(({ theme }) => ({
    "& .MuiSlider-thumb": {
      transition: "3s ease-in-out",
      color: colors?.main_buttons,
    },
    "& .MuiSlider-track": {
      transition: "3s ease-in-out",
      color: "#fff",
    },
    "& .MuiSlider-rail": {
      //transition: '3s ease-in-out',
      color: "#F6F6F6",
    },
  }));

  const valuetext = (value: number) => {
    return `${value}`;
  };

  const handleMouseMove = (e) => {
    const div: any = sliderRef.current;
    if (dragging) {
      if (div) {
        const rect = div.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;

        // Calcular el ángulo relativo al centro del círculo
        const angle = Math.atan2(centerY - e.clientY, centerX - e.clientX);
        let angleDegrees = (angle * 180) / Math.PI;

        // Ajustar el rango de -180 a 180 grados a un rango de 0 a 360 grados
        if (angleDegrees < 1) {
          angleDegrees += 360;
        }

        const grados = angleDegrees; // El ángulo en grados que quieres convertir
        const framesTotales = 100; // El total de frames en 360 grados
        let frames = Math.round((grados / 360) * framesTotales);

        // evitar que sea 0
        frames = Math.max(1, frames);

        //console.log(`Ángulo en grados: ${grados}, Frames: ${frames}`);
        //console.log(angleDegrees);
        setAngle(angleDegrees);
        setSelectedTime(frames);
      }
    }
  };

  const handleMouseDown = (e) => {
    setDragging(true);
    setStartX(e.clientX);
    setStartY(e.clientY);
  };

  const handleMouseUp = () => {
    setDragging(false);
  };

  const handleTouchMove = (e) => {
    const div: any = sliderRef.current;
    if (dragging) {
      if (div) {
        const rect = div.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;

        // Usar el primer punto de contacto
        const touch = e.touches[0];

        // Calcular el ángulo relativo al centro del círculo
        const angle = Math.atan2(
          centerY - touch.clientY,
          centerX - touch.clientX
        );
        let angleDegrees = (angle * 180) / Math.PI;

        // Ajustar el rango de -180 a 180 grados a un rango de 0 a 360 grados
        if (angleDegrees < 0) {
          angleDegrees += 360;
        }

        const grados = angleDegrees; // El ángulo en grados que quieres convertir
        const framesTotales = 100; // El total de frames en 360 grados
        let frames = Math.round((grados / 360) * framesTotales);

        // evitar que sea 0
        frames = Math.max(1, frames);

        //console.log(`Ángulo en grados: ${grados}, Frames: ${frames}`);
        //console.log(angleDegrees);
        setAngle(angleDegrees);
        setSelectedTime(frames);
      }
    }
  };

  const handleTouchStart = (e) => {
    setDragging(true);

    // Usar el primer punto de contacto
    const touch = e.touches[0];
    setStartX(touch.clientX);
    setStartY(touch.clientY);
  };

  const handleTouchEnd = () => {
    setDragging(false);
  };

  const darkenColor = (color, percent) => {
    const f = parseInt(color.slice(1), 16);
    const t = percent < 0 ? 0 : 255;
    const p = percent < 0 ? percent * -1 : percent;
    const R = f >> 16;
    const G = (f >> 8) & 0x00ff;
    const B = f & 0x0000ff;
    return (
      "#" +
      (
        0x1000000 +
        (Math.round((t - R) * p) + R) * 0x10000 +
        (Math.round((t - G) * p) + G) * 0x100 +
        (Math.round((t - B) * p) + B)
      )
        .toString(16)
        .slice(1)
    );
  };

  return !isPortrait ? (
    <div
      className={`asoleacion-container ${theme}`}
      onMouseUp={() => {
        setDragging(false);
      }}
      onTouchEnd={() => {
        setDragging(false);
      }}
    >
      <div
        className={`asoleacion-button ${isSideBar ? "hidden" : "show"}`}
        onMouseOver={(e) => {
          e.currentTarget.style.backgroundColor = darkenColor(
            colors?.main_buttons,
            0
          );
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.backgroundColor = "";
        }}
        onClick={() => {
          setIsSideBar(true),
            setSelectedTime(keyTime),
            setAngle((keyTime / 100) * 360);
        }}
      >
        <img src={asoleacion} alt="Asoleación" />
        {!isPortrait ? <div>Asoleación</div> : null}
      </div>
      <div
        className={`asoleacion-sidebar ${
          isSideBar ? "show" : !isSideBar && alt ? "alt" : "hidden"
        }`}
        onAnimationEnd={() => {
          if (!isSideBar) setIsSideBar(false);
        }}
      >
        <div className="asoleacion-sidebar-close">
          <div
            className="setting-boton-circular"
            onClick={() => {
              setIsSideBar(false), setIsVew({});
            }}
          >
            <i className="fas fa-xmark"></i>
          </div>
        </div>
        <div className="asoleacion-sidebar-logo">
          <img src={`./UI/asoleacion/modalIcon.svg`} alt="" />
          <div className="asoleacion-sidebar-title">ASOLEACIÓN</div>
        </div>
        <div className="asoleacion-sidebar-vistas">
          <div className="asoleacion-sidebar-vistas-title">VISTAS</div>
          <div className="asoleacion-sidebar-vistas-buttons">
            {vistas?.map((v, i) => (
              <div
                className={`asoleacion-sidebar-vistas-button vista-${i}`}
                key={`vista-${i}`}
                onClick={() => {
                  setIsVew(v),
                    setFrame(v?.frame),
                    setSelectedTime(keyTime),
                    setAngle((keyTime / 100) * 360);
                }}
                style={
                  isView?.name === v.name
                    ? { backgroundColor: colors?.main_buttons, color: "#fff" }
                    : {}
                }
                onMouseOver={(e) => {
                  if (isView?.name !== v.name) {
                    e.currentTarget.style.backgroundColor = darkenColor(
                      colors?.main_buttons,
                      0
                    );
                  }
                }}
                onMouseOut={(e) => {
                  if (isView?.name !== v.name) {
                    e.currentTarget.style.backgroundColor = "";
                  }
                }}
              >
                {v.name}
              </div>
            ))}
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            className="asoleacion-sidebar-slider"
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
            ref={sliderRef}
          >
            <div
              className="asoleacion-sidebar-slider-ball"
              onMouseDown={handleMouseDown}
              onMouseMove={handleMouseMove}
              onMouseUp={handleMouseUp}
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
              /* style={{
                  transform: `rotate(${
                    selectedTime * (360 / 175)
                  }deg) translate(${radius}rem) rotate(-${
                    selectedTime * (360 / 175)
                  }deg)`,
                  cursor: dragging ? "grabbing" : "grab",
                }} */
              style={{
                transform: `rotate(${angle - 1.5}deg) translate(${
                  !window.functionIsPortrait() &&
                  window.functionIsMobileDevice()
                    ? 2.75
                    : 5.3
                }rem) rotate(-${angle + 1.5}deg)`,
                cursor: dragging ? "grabbing" : "grab",
              }}
            >
              <div
                onMouseDown={handleMouseDown}
                onMouseMove={handleMouseMove}
                onMouseUp={handleMouseUp}
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
                style={{
                  cursor: dragging ? "grabbing" : "grab",
                  backgroundColor: colors?.main_buttons,
                }}
              ></div>
            </div>
            <div className="asoleacion-sidebar-slider-internal"></div>

            <div
              className="asoleacion-sidebar-slider-dia"
              style={{
                right: "calc(50% - 8px)",
                bottom:
                  !window.functionIsPortrait() &&
                  window.functionIsMobileDevice()
                    ? "-1.5rem"
                    : "-2rem",
              }}
            >
              <img src={mediodiaIcon} alt="Medio día" className="slider-icon" />
            </div>
            <div
              className="asoleacion-sidebar-slider-dia"
              style={{
                left:
                  !window.functionIsPortrait() &&
                  window.functionIsMobileDevice()
                    ? "-1.5rem"
                    : "-2rem",
                bottom: "calc(60% - 25px)",
              }}
            >
              <img
                src={atardecerIcon}
                alt="Atardecer"
                className="slider-icon"
              />
            </div>
            <div
              className="asoleacion-sidebar-slider-dia"
              style={{
                left: "4.5rem",
                bottom: "calc(100% + 16px)",
              }}
            >
              <img src={nocheIcon} alt="Noche" className="slider-icon" />
            </div>
            <div
              className="asoleacion-sidebar-slider-dia"
              style={{
                right:
                  !window.functionIsPortrait() &&
                  window.functionIsMobileDevice()
                    ? "-1.5rem"
                    : "-2rem",
                bottom: "calc(50% - 10px)",
              }}
            >
              <img src={amanecerIcon} alt="Amanecer" className="slider-icon" />
            </div>
          </div>
        </div>
        <div className="asoleacion-sidebar-vistas-horas row">
          {marks.map((e) => e.label)}
          <div
            className="asoleacion-sidebar-vistas-buttons-auto col col-12"
            onClick={() => animacionAUT()}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = darkenColor(
                colors?.main_buttons,
                0
              );
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = "";
            }}
          >
            Animación Automática
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div
      className={`asoleacion-container ${theme}`}
      onMouseUp={() => {
        setDragging(false);
      }}
      onTouchEnd={handleTouchEnd}
    >
      <div
        className={`asoleacion-button ${isSideBar ? "hidden" : "show"}`}
        onClick={() => {
          setIsSideBar(true),
            setSelectedTime(keyTime),
            setAngle((keyTime / 100) * 360);
        }}
      >
        <img src={asoleacion} alt="Asoleación" />
      </div>
      <div
        className={`asoleacion-sidebar-mobile ${
          isSideBar ? "show" : !isSideBar && alt ? "alt" : "hidden"
        }`}
        onAnimationEnd={() => {
          if (!isSideBar) setIsSideBar(false);
        }}
      >
        {/* <div className="asoleacion-sidebar-close-mobile ">
          <div
            className="setting-boton-circular"
            onClick={() => {
              setIsSideBar(false), setIsVew({});
            }}
          >
            <i className="fas fa-xmark"></i>
          </div>
        </div> */}
        <div className="asoleacion-sidebar-logo">
          <img src={`./UI/asoleacion/modalIcon.svg`} alt="" />
          <div className="asoleacion-sidebar-title">ASOLEACIÓN</div>
        </div>
        <div className="asoleacion-sidebar-vistas">
          <div className="asoleacion-sidebar-vistas-title">VISTAS</div>
          <div className="asoleacion-sidebar-vistas-buttons">
            {vistas?.map((v, i) => (
              <div
                className="asoleacion-sidebar-vistas-button"
                key={`as-${i}`}
                onClick={() => {
                  setIsVew(v),
                    setFrame(v?.frame),
                    setSelectedTime(keyTime),
                    setAngle((keyTime / 100) * 360);
                }}
                style={
                  isView?.name === v.name
                    ? { backgroundColor: colors?.main_buttons, color: "#fff" }
                    : {}
                }
              >
                {v.name}
              </div>
            ))}
            {/* <div
              className="asoleacion-sidebar-vistas-buttons-auto"
              onClick={() => animacionAUT()}
            >
              Animación Automática
            </div> */}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
          }}
        >
          <div className="asoleacion-sidebar-slider-container">
            <Slider
              aria-label="time-indicator"
              size="small"
              value={selectedTime}
              min={1}
              step={1}
              max={100}
              onChange={(_, value) => setSelectedTime(value as number)}
              marks={marks_movil}
              sx={{
                color:
                  themee.palette.mode === "dark" ? "#fff" : "rgba(0,0,0,0.87)",
                height: 4,
                "& .MuiSlider-thumb": {
                  width: 24,
                  height: 24,
                  color: colors?.main_buttons,
                  transition: "3s ease",
                  "&::before": {
                    boxShadow: "0 2px 12px 0 rgba(0,0,0,0.4)",
                  },
                  "&:hover, &.Mui-focusVisible": {
                    boxShadow: `0px 0px 0px 8px ${
                      themee.palette.mode === "dark"
                        ? "rgb(255 255 255 / 16%)"
                        : "rgb(0 0 0 / 16%)"
                    }`,
                  },
                  "&.Mui-active": {
                    width: 20,
                    height: 20,
                  },
                },
                "& .MuiSlider-track": {
                  transition: "3s ease",
                  color: "#fff",
                },
                "& .MuiSlider-rail": {
                  opacity: 0.28,
                },
              }}
            />
          </div>
        </div>
        <div className={`sidebar-container-portrait-close  ${theme}`}>
          <div
            className="setting-boton-circular"
            onClick={() => {
              setIsSideBar(false), setIsVew({});
            }}
          >
            <i className="fas fa-xmark"></i>
          </div>
        </div>
      </div>
    </div>
  );
}
